const getuseridReducer = (state = { userIdState: [] }, action) => {
    switch (action.type) {
        case "GET_USERID":
            return {
                userIdState: action.userIdState
            }

        default:
            return state;
    }
}

export default getuseridReducer;


// WEBPACK FOOTER //
// ./src/reducer/getuseridreducer.jsx